<div class="ant-list-item-meta-avatar">
  <ui-avatar *ngIf="nzSrc" [uiPicture]="nzSrc" uiType="picture"></ui-avatar>
  <ng-content *ngIf="!nzSrc"></ng-content>
</div>
